import React, {Component} from "react";
import PropTypes from "prop-types";
import {withStyles} from "@material-ui/core/styles";
import {getTranslation} from "../../helpers/get-translation";

const styles = theme => ({
    level: {
        minHeight: "100px",
        width: "85%",
        margin: "10px auto",
        borderRadius: "15px",
        padding: "15px",
        border: "1px solid #d2d0d0",
        background: getTranslation("adsens_background_color")
        // background: "linear-gradient(-45deg, #e7e7e7 0%, #e7e7e7 46%, #F8F8F8 50%, #e7e7e7 65%, #e7e7e7 100%)",
        // backgroundSize: "200% 200%",
        // animation: "pulse 0.8s cubic-bezier(0.55, 0.085, 0.68, 0.53) infinite; infinite",
        // "user-select": "none",
    },
    none: {
        display: "none"
    }
});

class AdLevel extends Component{
    state = {
        areAdsEnabled: true
    };

    componentDidMount(){
        if(window.adsbygoogle === undefined){
            this.setState({ areAdsEnabled: false })
        } else {
            (window.adsbygoogle = window.adsbygoogle || []).push({});
        }
    }

    render() {
        const { classes} = this.props;

        const className = this.state.areAdsEnabled ? classes.level : classes.none;

        return (
            <div className={className} id="ad-level-container">
                <ins className="adsbygoogle"
                     style={{display:'block'}}
                     data-ad-client={getTranslation("adsens_data_ad_client")}
                     data-ad-layout-key={getTranslation("adsens_data_ad_layout_key")}
                     data-ad-slot={getTranslation("adsens_data_ad_slot")}
                     data-ad-format={getTranslation("adsens_data_ad_format")}>
                </ins>
            </div>

        );

    }
}

AdLevel.propTypes = {
    id: PropTypes.string.isRequired,

    classes: PropTypes.shape({
        level: PropTypes.string.isRequired,
    }).isRequired,

};

export default withStyles(styles)(AdLevel);
